import { TogglesReduxState } from '@news-mono/web-common'
import { getThemedSegment } from './get-themed-segment'
import { toFeatureState } from '@west-australian-newspapers/etrigan-feature-toggles-client'

export const commonwealthGamesSegment = (toggles: TogglesReduxState) => {
    const featureState = toFeatureState(toggles)

    return getThemedSegment({
        featureToggle: 'commonwealth-games-4card-curation',
        featureState,
        layoutVersion: '4-card',
        curation: 'commonwealth-games',
        themeOverride: 'commonwealth-games',
        cardExtensionProps: {
            fourCardExtension: {
                kind: '4-card',
                limaProps: {
                    heroCardOnMobile: true,
                    hideBottomBorder: true,
                    hideEditorialType: true,
                },
            },
        },
    })
}
